import { usePlatformPutCustomColumnValues } from '@cloudquery/api-platform';
import toast from 'react-hot-toast';

export function useCustomColumnEdit() {
  const { mutateAsync } = usePlatformPutCustomColumnValues();

  const editCustomColumnValues = async ({
    customColumnId,
    rowIds,
    successMessage,
    teamName,
    value,
  }: {
    customColumnId: string;
    rowIds: string[];
    successMessage: string;
    teamName: string;
    value: any;
  }): Promise<boolean> => {
    try {
      await mutateAsync({
        customColumnId,
        data: {
          data: rowIds.map((id: string) => ({
            cq_id: id,
            value,
          })),
        },
        teamName,
      });
      toast.success(successMessage);

      return true;
    } catch {
      toast.error('Failed to update column values');

      return false;
    }
  };

  return { editCustomColumnValues };
}
